// components/Loader.js
import React from "react";

const Loader = () => (
  <div style={styles.overlay}>
    <div style={styles.spinner}></div>
    <p style={styles.text}>Cargando...</p>
  </div>
);

const styles = {
  overlay: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #e5e7eb",
    borderTop: "4px solid #0080ff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  text: {
    marginTop: "12px",
    fontSize: "14px",
    color: "#6b7280",
    fontWeight: 400,
    fontFamily: "'FT Habit', -apple-system, BlinkMacSystemFont, sans-serif",
  },
};

export default Loader;
